import { axiosInstance } from 'src/services/api.js';
import { fadeOut } from 'src/utils/animation.js';
import { delegateEvent } from 'src/utils/dom.js';

delegateEvent(document, 'click', '[data-close-notice]', (event, target) => {
  event.preventDefault();
  axiosInstance.delete(target.href);
  fadeOut(target.closest('[data-notice]'));
});